import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GenericResponse } from '../model/genericResponse';
import { SearchResult } from '../model/search/serach-result';

@Injectable()
export class SearchResolverService  {

  constructor(private http: HttpClient) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<GenericResponse<SearchResult[]>> |
    Observable<Observable<GenericResponse<SearchResult[]>>> | Promise<Observable<GenericResponse<SearchResult[]>>> {
    return this.search();
  }
  public search(): Observable<GenericResponse<SearchResult[]>> {
    const params = new HttpParams().append('permit', 'false');

    return this.http.get<GenericResponse<SearchResult[]>>('', { params: params });

  }
}
